{% block sw_cms_block_acris_blog_product_slider %}
    <div class="sw-cms-preview-acris-blog-product-slider">
        <mt-icon
                name="regular-chevron-left"
                size="20"
        />
        <div class="sw-cms-preview-acris-blog-product-slider__product-box">
            <sw-cms-product-box-preview has-text />
            <sw-cms-product-box-preview has-text />
        </div>
        <mt-icon
                name="regular-chevron-right"
                size="20"
        />
    </div>
{% endblock %}
